import { useMemo } from 'react';

import { useCacheQuery } from '../../../hooks/use-cache-query';
import {
  GetHonorificBlockTimesDocument,
  GetHonorificBlockTimesQueryVariables,
  HonorificBlockTimeItemDataFragment,
} from '../../types/api/graphql';

// get block times of honorific
export function useHonorificBlockTimeItems(
  variables: GetHonorificBlockTimesQueryVariables,
  skip?: boolean
) {
  const {
    data: honorificBlockTimeItemsData,
    loading: honorificBlockTimeItemsLoading,
  } = useCacheQuery(GetHonorificBlockTimesDocument, {
    variables: {
      ...variables,
    },
    skip: skip === true,
  });

  const data = useMemo(
    () =>
      honorificBlockTimeItemsData?.honorificBlockTimes as HonorificBlockTimeItemDataFragment[],
    [honorificBlockTimeItemsData]
  );

  return {
    data,
    loading: honorificBlockTimeItemsLoading,
  };
}
